var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tab-pane fade in active", attrs: { id: "tab_charts" } },
    [
      _c("div", { staticClass: "tab__header" }, [
        _vm._v("Monthly Trending Charts")
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-sm-6" }, [
          _c(
            "div",
            { staticClass: "basic-card" },
            [
              _c("div", { staticClass: "basic-card__card-title" }, [
                _vm._v("Hearing Test Trends")
              ]),
              _vm._v(" "),
              _c("HearingTestTrends")
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-6" }, [
          _c(
            "div",
            { staticClass: "basic-card" },
            [
              _c("div", { staticClass: "basic-card__card-title" }, [
                _vm._v("HAE/Opportunity Trends")
              ]),
              _vm._v(" "),
              _c("HaeOpportunityTrends")
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-sm-6" }, [
          _c(
            "div",
            { staticClass: "basic-card" },
            [
              _c("div", { staticClass: "basic-card__card-title" }, [
                _vm._v("# Patients Purchased Trends")
              ]),
              _vm._v(" "),
              _c("PatientsPurchasedTrends")
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-6" }, [
          _c(
            "div",
            { staticClass: "basic-card" },
            [
              _c("div", { staticClass: "basic-card__card-title" }, [
                _vm._v("Unit Trends")
              ]),
              _vm._v(" "),
              _c("UnitTrends")
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-sm-6" }, [
          _c(
            "div",
            { staticClass: "basic-card" },
            [
              _c("div", { staticClass: "basic-card__card-title" }, [
                _vm._v("Net Revenue Trends")
              ]),
              _vm._v(" "),
              _c("NetRevenueTrends")
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-6" }, [
          _c(
            "div",
            { staticClass: "basic-card" },
            [
              _c("div", { staticClass: "basic-card__card-title" }, [
                _vm._v("Net Margin Trends")
              ]),
              _vm._v(" "),
              _c("NetMarginTrends")
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-sm-6" }, [
          _c(
            "div",
            { staticClass: "basic-card" },
            [
              _c("div", { staticClass: "basic-card__card-title" }, [
                _vm._v("Net Profit Trends")
              ]),
              _vm._v(" "),
              _c("NetProfitTrends")
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-6" }, [
          _c(
            "div",
            { staticClass: "basic-card" },
            [
              _c("div", { staticClass: "basic-card__card-title" }, [
                _vm._v("Average Sale Price Trends")
              ]),
              _vm._v(" "),
              _c("AverageSalePriceTrends")
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _c("div", { staticClass: "basic-card benchmark-desc" }, [
          _vm._v("\n        The "),
          _c("span", { staticClass: "benchmark-low" }, [_vm._v("Low")]),
          _vm._v(", "),
          _c("span", { staticClass: "benchmark-median" }, [_vm._v("Median")]),
          _vm._v(" and "),
          _c("span", { staticClass: "benchmark-high" }, [_vm._v("High")]),
          _vm._v(
            " benchmark lines on each chart represent benchmarks inside of Fuel practices. For the total practice, these lines are calculated by taking the individual provider benchmarks and multiplying them by the average # of providers inside of your practice. Click on the ‘Benchmarks’ tab above to see more about how your practice compares to these benchmarks.\n      "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }